import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";

import { environment } from "../../../../environments/environment";

import { MyAuthService } from "../../auth.service";
import { ApiService } from "../../../services/api.service";
import { SharedService } from "../../../services/shared.service";
import { AuthService } from "angularx-social-login";
import { SocialUser } from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"]
})
export class RegisterComponent implements OnInit {
  public siteKey = environment.reCatchSiteKey;
  public regForm;
  public regEmail = "";
  public isSubmitted = false;
  //public termConditionIsChecked = false;
  public isError = false;
  public passwordType = "password";
  public confirmPasswordType = "password";
  public regSuccess = false;
  public regError = "";
  public regType = 0;
  user: SocialUser;
  public successMsgTitle =
    "A Verification link has been sent to your registered email ";
  public successMsg =
    "Please clik on the link that has been sent to your email account to verify your email" +
    " and continue the registration processs.";

  public userTypes = [
    "Student",
    "Retail Investor",
    "Institutional Investor",
    "Company",
    "Fund Manager",
    "Broker",
    "Investment Banker",
    "Other"
  ];
  @Input() showModal = false;
  @Output() closeRegister = new EventEmitter<string>();
  @Output() showLogin = new EventEmitter<string>();

  constructor(
    private authService: MyAuthService,
    private router: Router,
    private apiService: ApiService,
    private _shared: SharedService,
    private socialAuth: AuthService
  ) {
    this.authService.userData.subscribe(userData => {
      if (userData) {
        //console.log("Logged Redirect Reg");
        this.router.navigate(["user/my-dashboard"]);
      }
    });
    this._shared.getRegistrationType.subscribe(regType => {
      //console.log(regType);
      this.regType = regType;
    });
  }
  ngOnInit() {
    this.createForm();
    this.socialAuth.authState.subscribe(user => {
      this.user = user;
      //console.log("User", this.user);
    });
  }
  private createForm() {
    this.regForm = new FormGroup({
      // tslint:disable-next-line
      //Email , patternValidator(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      first_name: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(30),
          this._shared.CheckIfOnlyAlphabets()
        ])
      ),
      last_name: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(30),
          this._shared.CheckIfOnlyAlphabets()
        ])
      ),
      email: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.email])
      ),
      userType: new FormControl(
        "Student",
        Validators.compose([Validators.required])
      ),
      // mobile: new FormControl('', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(10)])),
      password: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.minLength(6)])
      ),
      confirmpassword: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.minLength(6)])
      ),
      recaptcha: new FormControl("", Validators.compose([Validators.required])),
      termConditionIsChecked: new FormControl(false, Validators.requiredTrue)
    });
  }
  get formControls() {
    return this.regForm.controls;
  }

  register() {
    //console.log("register");
    this.isSubmitted = true;
    //this.termConditionIsChecked = false;
    if (this.regForm.invalid) {
      return;
    }
    //console.log(this.regForm.valid, this.regForm.value);
    if (
      this.regForm.valid &&
      this.regForm.value.password === this.regForm.value.confirmpassword
    ) {
      const data = {
        first_name: this.regForm.value.first_name,
        last_name: this.regForm.value.last_name,
        email: this.regForm.value.email,
        user_type: this.regForm.value.userType,
        password: this.regForm.value.password,
        confirmpassword: this.regForm.value.confirmpassword,
        captcha_response: this.regForm.value.recaptcha,
        accept_terms: this.regForm.value.termConditionIsChecked,
        subscribe: this.regType === 2 ? true : false
      };
      this.apiService.registerUser(data).subscribe(
        res => {
          //console.log("res", res);
          this.isSubmitted = false;
          if (res.message) {
            this.regEmail = this.regForm.value.email;
            this.regForm.reset();
            this.regSuccess = true;
          } else {
            this.regSuccess = false;
            this.regError = res.message;
          }
        },
        err => {
          console.log(err, err.headers);
          if (err.error) {
            this.isSubmitted = false;
            this.regSuccess = false;
            this.regError = err.error.message;
          }
        }
      );
    }
  }

  confirmPasswordValidator(group: FormGroup) {
    const password = group.controls.password.value;
    const passwordConfirmation = group.controls.confirmpassword.value;
    return password === passwordConfirmation
      ? null
      : { mismatch: passwordConfirmation };
  }

  close(regEmail) {
    // console.log('closemodal')
    // if (this.regType === 2) {
    //   this._shared.toggleMobileVerify(regEmail);
    // }
    this.closeRegister.emit("false");
  }

  hideRegister() {
    this.showLogin.emit();
  }
  showPassword() {
    this.passwordType = this.passwordType === "password" ? "text" : "password";
  }
  showConfirmPassword() {
    this.confirmPasswordType =
      this.confirmPasswordType === "password" ? "text" : "password";
  }

  onCheckboxChange(event: any) {
    const checked = event.target.checked;
    console.log("Checked:", checked);
    //this.termConditionIsChecked = checked;
  }

  signInWithGoogle(): void {
    // this.isSubmitted = true;
    this.socialAuth.signIn(GoogleLoginProvider.PROVIDER_ID).then(userData => {
      //console.log("result ", userData);
      const subscribe = this.regType === 2 ? true : false;
      this.apiService
        .socialSignIn({
          provider: "google",
          id_token: this.user.idToken,
          subscribe: subscribe
        })
        .subscribe(
          result => {
            //console.log("api response", result);
            if (result.access_token) {
              this.authService.login(result);
              this.regEmail = userData.email;
              this.regError = "";
              if (this.regType === 2) {
                this.regSuccess = true;
              } else {
              }
            } else {
              // this.isSubmitted = false;
              this.regError = result.message
                ? result.message
                : "Something went wrong. Please Try again later.";
            }
          },
          err => {
            console.log(err);
            if (err.error) {
              this.isSubmitted = false;
              this.regError = err.error.message;
            }
          }
        );
    });
  }

  handleSuccess(e) {
    console.log("reCaptcha Response", e);
  }
  handleLoad() {
    console.log("reCaptcha Loaded");
  }

  handleReset() {
    console.log("reCaptcha Reset");
  }

  handleExpire() {
    console.log("reCaptcha Expired");
  }
}
